import Constants from "src/helper/Constants";

const { INTERNAL_SEARCH_COMPLETED, TYPEHEAD_SEARCH, SEARCH_FILTER_APPLIED, BOM_FILE_UPLOAD,
        BOM_RENAME, BOM_OPENED, BOM_QUICKLY_PART, BOM_EMAIL, CREATE_BOM, ADD_TO_BOM, 
        BOM_SELECTION_MULTIPLE_RESOLVED, BOM_REMOVE_MULTIPLE_RESOLVED, BOM_PRODUCT_REMOVAL,
        BOM_REMOVE_NO_MATCH_RESOLVED, BOM_NO_MATCH_RESOLVED, PRODUCT_VIEW, ADD_TO_CART, CART_CHECKOUT, CHECKOUT_STEP_1,
        CHECKOUT_STEP_2, CHECKOUT_STEP_3, PURCHASE, CART_REMOVAL, CART_VIEW, CART_OPEN, BOM_ADD_ITEM_TO_CART,
        DOWNLOADS, EXPORTS, BOM_DOWNLOAD, ERROR_DETAILS, FORM_START, FORM_SUBMISSION, REGISTRATION_START, REGISTRATION_COMPLETE, CTACLICK } = Constants.AnalyticsEvents
class HelperAnalyticsEvent {

    static defaultInfo = () => {
        return {
            pageInfo: window.adobeDataLayer?.[0]?._avnet?.pageInfo || {},
            userInfo: window.adobeDataLayer?.[0]?._avnet?.userInfo || {}
        }
    }

    static internalSearchEvent = (dataPoints) => {
        let searchDetails = dataPoints.searchDetails;
        const searchEvent = {
            event: INTERNAL_SEARCH_COMPLETED,
            _avnet: {
                internalSearchInfo: {
                    searchType: "internal",
                    searchTab: "Products",
                    ...searchDetails
                },
                ...this.defaultInfo()
            },
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(searchEvent);
    }

    static typeheadSearchEvent = (dataPoints) => {
        let searchDetails = dataPoints.searchDetails;
        const searchEvent = {
            event: TYPEHEAD_SEARCH,
            _avnet: {
                internalSearchInfo: {
                    searchType: "Internal",
                    ...searchDetails.internalSearchInfo
                },
                linkInfo: {
                    linkLocation: "typeheadSearchResults",
                    linkType: "link",
                    linkComponent: "typeheadPopup",
                    ...searchDetails.linkInfo
                },
                ...this.defaultInfo()
            },
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(searchEvent);
    }

    static searchFilterApply = (dataPoints) => {
        let filterDetails = dataPoints.filterDetails;
        const filterApplyEvent = {
            event: SEARCH_FILTER_APPLIED,
            _avnet: {
                internalSearchInfo: {
                    searchType: "Internal",
                    ...filterDetails
                },
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(filterApplyEvent);
    }

    static bomFileUpload = (dataPoints) => {
        const bomFileUploadEvent = {
            event: BOM_FILE_UPLOAD,
            _avnet: {
                bomInfo: dataPoints.bomInfo,
                ...this.defaultInfo()
            },
        }
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(bomFileUploadEvent);
    }

    static bomRename = (dataPoints) => {
        const bomRenameEvent = {
            event: BOM_RENAME,
            _avnet: {
                bomInfo: dataPoints.bomInfo,
                ...this.defaultInfo()
            },
        }
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(bomRenameEvent);
    }

    static bomOpened = (dataPoints) => {
        let { productListItems, bomInfo } = dataPoints;
        const bomOpen = {
            event: BOM_OPENED,
            _avnet: {
                productListItems: productListItems,
                bomInfo: bomInfo,
                ...this.defaultInfo(),
                dateTimestamp: this.getCurrentTimeStamp()
            },
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(bomOpen);
    }

    static bomQuicklyAddPart = (dataPoints) => {
        let { productListItems, bomInfo } = dataPoints;
        const bomQuicklyAddPart = {
            event: BOM_QUICKLY_PART,
            _avnet: {
                productListItems: productListItems,
                bomInfo: bomInfo,
                ...this.defaultInfo(),
                dateTimestamp: this.getCurrentTimeStamp()
            },
        };
        // this.getWindowObj();
        window?.adobeDataLayer?.push(bomQuicklyAddPart);
    }

    static bomEmail = ({ bomInfo }) => {
        const emailBOM = {
            event: BOM_EMAIL,
            _avnet: {
                bomInfo: bomInfo,
                ...this.defaultInfo()
            },
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(emailBOM);
    }

    static createBOM = (dataPoints) => {
        let { productList, bomInfo } = dataPoints;
        const createBOM = {
            "event": CREATE_BOM,
            "_avnet": {
                productListItems: this.getBOMProductListItems(productList),
                bomInfo: bomInfo,
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(createBOM);
    }

    static addToBOM = (dataPoints) => {
        let { productList, bomInfo } = dataPoints;
        const addToBOM = {
            "event": ADD_TO_BOM,
            "_avnet": {
                productListItems: this.getBOMProductListItems(productList),
                bomInfo: bomInfo,
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(addToBOM);
    }

    static bomMultipleMatch = (dataPoints) => {
        let { productList, bomInfo } = dataPoints;
        const bomMultiMatch = {
            "event": BOM_SELECTION_MULTIPLE_RESOLVED,
            "_avnet": {
                productListItems: this.getBOMProductListItems(productList, 'bomProdSelectionMultipleResolved'),
                bomInfo: bomInfo,
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(bomMultiMatch);
    }

    static bomMultipleMatchRemove = (dataPoints) => {
        const { productList, bomInfo } = dataPoints;
        const bomMultiMatchRemove = {
            "event": BOM_REMOVE_MULTIPLE_RESOLVED,
            "_avnet": {
                productListItems: [{
                    merchandising: {
                        partNumberEntered: productList[0]?.partNumber,
                        dateTimestamp: this.getCurrentTimeStamp()
                    }
                }],
                bomInfo: bomInfo
            }
        }
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(bomMultiMatchRemove);
    }

    static bomExactMatchRemove = (dataPoints) => {
        let { productList, bomInfo } = dataPoints;
        const bomMultiMatch = {
            "event": BOM_PRODUCT_REMOVAL,
            "_avnet": {
                productListItems: this.getBOMProductListItems(productList, 'bomProductRemoval'),
                bomInfo: bomInfo,
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(bomMultiMatch);
    }

    static bomNoMatchResolve = (dataPoints) => {
        let { productList, bomInfo } = dataPoints;
        const bomNoMatchResolve = {
            "event": BOM_NO_MATCH_RESOLVED,
            "_avnet": {
                productListItems: this.getBOMProductListItems(productList, 'bomNoMatchesResolved'),
                bomInfo: bomInfo,
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(bomNoMatchResolve);
    }

    static bomNoMatchRemove = (dataPoints) => {
        const { productList, bomInfo } = dataPoints;
        const bomNoMatchRemove = {
            "event": BOM_REMOVE_NO_MATCH_RESOLVED,
            "_avnet": {
                productListItems: [{
                    merchandising: {
                        partNumberEntered: productList[0]?.partNumber,
                        dateTimestamp: this.getCurrentTimeStamp()
                    }
                }],
                bomInfo: bomInfo
            }
        }
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(bomNoMatchRemove);
    }

    static productView = (dataPoints) => {
        let { productList } = dataPoints;
        const productView = {
            "event": PRODUCT_VIEW,
            "_avnet": {
                productListItems: this.getBOMProductListItems(productList, 'productView'),
                "ecommerce": {
                    "currencyCode": window?.mct,
                },
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(productView);
    }

    static addToCart = (dataPoints) => {
        let { productList, cartId, bomInfo } = dataPoints;
        const addToCartEvent = {
            "event": ADD_TO_CART,
            "_avnet": {
                productListItems: this.getBOMProductListItems(productList, 'addToCart'),
                "ecommerce": {
                    "cartID": cartId
                },
                ...(bomInfo ? { bomInfo } : {}),
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(addToCartEvent);
    }

    static cartEvent = (dataPoints) => {
        let { productList, eventName } = dataPoints;
        const cartEvent = {
            "event": eventName,
            "_avnet": {
                productListItems: this.getBOMProductListItems(productList, eventName),
                "ecommerce": {
                    "cartID": productList?.[0]?.cartId
                },
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(cartEvent);
    }

    static getBOMProductListItems = (productList, event) => {
        const backOrderEvents = [BOM_OPENED, CREATE_BOM, ADD_TO_BOM,
            CART_CHECKOUT, CHECKOUT_STEP_1, CHECKOUT_STEP_2,
            CHECKOUT_STEP_3, PURCHASE, 'addToQuoteFromBOM', BOM_ADD_ITEM_TO_CART, PURCHASE, CART_VIEW];
        const cartEvents = [ADD_TO_CART, CART_OPEN, CART_VIEW, CART_REMOVAL, CART_CHECKOUT, BOM_ADD_ITEM_TO_CART, PURCHASE];
        const qtyEvents = [PRODUCT_VIEW, ADD_TO_CART, CART_OPEN, CART_VIEW, CART_REMOVAL, CART_CHECKOUT,
            CHECKOUT_STEP_1, CHECKOUT_STEP_2, CHECKOUT_STEP_3, BOM_ADD_ITEM_TO_CART];
        const assetEvents = [CREATE_BOM, PRODUCT_VIEW, ADD_TO_CART, CART_OPEN, CART_VIEW, CART_REMOVAL,
            CART_CHECKOUT, CHECKOUT_STEP_1, CHECKOUT_STEP_2, CHECKOUT_STEP_3, BOM_ADD_ITEM_TO_CART]
        if (!Array.isArray(productList) || productList.length === 0) return [];

        return productList.map((prod) => {
            let baseObj = {
                SKU: prod?.ItemNumber || prod?.itemNumber,
                name: prod?.ERPPartNumber || prod?.erpPartNumber || prod?.partNumber,
                currencyCode: prod?.currency || window?.mct,
                quantity: prod?.Quantity || prod?.quantity,
                priceTotal: prod?.subTotal?.toFixed(2) || prod?.subtotal?.toFixed(2) || '',
                merchandising: {
                    category: prod?.categoryListing?.map(x => x.value).join(', ') || '',
                    erpPartKey: prod?.ERPPartNumber || prod?.erpPartNumber || prod?.partNumber,
                    miAddItemToCartDetail: undefined,
                    pimPartKey: prod?.ItemNumber || prod.itemNumber,
                    supplierID: prod?.ERPSupplierCode || '',
                    supplierName: prod?.supplierName || '',
                    supplierPartNumber: prod?.supplierPartNumber || '',
                    manufacturerID: prod?.ManufacturerCode || prod?.manufacturerCode || prod?.erpManufacturerCode || '',
                    manufacturerName: prod?.ManufacturerName || prod?.manufacturerName || prod?.erpManufacturerName,
                    manufacturerPartNumber: prod?.ManufacturerPartNumber || prod?.manufacturerPartNumber,
                    quantityAddedToBOM: prod?.Quantity || prod?.quantity,
                    quantityAvailableForSale: prod?.qas,
                    backorderedQuantity: undefined,
                    priceType: undefined,
                    displayedPrice: prod?.unitPrice || '',
                    displayedPriceType: prod?.priceSource || '',
                    dateTimestamp: this.getCurrentTimeStamp(),
                    purchaseOrderNumber: undefined,
                    cartType: undefined,
                }
            };

            if ([BOM_PRODUCT_REMOVAL].includes(event)) {
                delete baseObj.merchandising.quantityAddedToBOM;
                baseObj.merchandising.quantityRemovedFromBOM = prod?.Quantity || prod?.quantity || 0;
            }

            if (backOrderEvents.includes(event)) {
                baseObj.merchandising.backOrderedQuantity = prod?.backOrderedQuantity ?? prod?.backOrderQuantity;
            }

            if (cartEvents.includes(event)) {
                baseObj.merchandising.cartType = 'checkout';
                if (![CART_REMOVAL, CART_CHECKOUT, PURCHASE].includes(event)) {
                    baseObj.merchandising.cartAdditionSource = prod?.source || '';
                }
            }

            if (qtyEvents.includes(event)) {
                ['quantityAddedToBOM', 'quantityAvailableForSale'].forEach((key) => {
                    const skipDelete = key === 'quantityAvailableForSale' && [CART_CHECKOUT, BOM_ADD_ITEM_TO_CART, 'checkout', PURCHASE, CART_VIEW, ADD_TO_CART].includes(event);
                    if (!skipDelete) delete baseObj.merchandising[key];
                });
            }

            if (event === BOM_ADD_ITEM_TO_CART) {
                baseObj.merchandising.miAddItemToCartDetail = baseObj.merchandising.erpPartKey;
                baseObj.merchandising.priceType = baseObj.currencyCode;
                baseObj.merchandising.quoteID = '';
                baseObj.merchandising.quoteType = '';
            }

            if (event === PURCHASE) {
                baseObj.merchandising.purchaseOrderNumber = prod?.purchaseOrderNumber || ''
            }
            const productImageUrl = assetEvents.includes(event) ? prod?.AssetURL || prod?.assetURL || '' : undefined;

            return {
                ...baseObj,
                ...(productImageUrl && { productImageUrl }),
            };
        });
    };

    static addToCartEvent = (dataPoints) => {
        const { productObj, pricingObj, cartId, isFrom } = dataPoints;
        let prodObj = {
            ...productObj,
            qas: productObj?.Stock || productObj?.currentStock || 0,
            unitPrice: (productObj.unitPrice || pricingObj?.marketPrice || 0),
            quantity: (productObj.Quantity || productObj?.quantity || productObj?.QtyMin),
            priceSource: pricingObj?.priceSource,
            subtotal: (productObj.subtotal || (pricingObj?.marketPrice * pricingObj?.quantity) || 0),
            source: isFrom,
            ERPSupplierCode: productObj.ERPSupplierCode
        }
        this.addToCart({
            productList: [prodObj],
            cartId: cartId
        })
    }

    static purchaseEvent = (dataPoints) => {
        const { productList, paymentInfo, orderInfo, shippingAmt, eventName } = dataPoints;
        const purchaseObj = {
            "event": PURCHASE,
            "_avnet": {
                "payments": paymentInfo,
                productListItems: this.getBOMProductListItems(productList, eventName),
                "ecommerce": {
                    "cartID": productList?.[0]?.cartId,
                    "shippingAmount": shippingAmt || 0
                },
                "orderDetails": orderInfo,
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(purchaseObj);
    }

    static downloadEvent = (dataPoints) => {
        let { download } = dataPoints;
        download = { ...download, timeStamp: this.getCurrentTimeStamp() };
        const downloadObj = {
            "event": DOWNLOADS,
            "_avnet": {
                "downloadInfo": download,
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(downloadObj);
    }

    static bomDownload = (dataPoints) => {
        let { downloadInfo, bomInfo } = dataPoints;
        downloadInfo = { ...downloadInfo, timeStamp: this.getCurrentTimeStamp() }
        const downloadObj = {
            "event": BOM_DOWNLOAD,
            "_avnet": {
                "downloadInfo": downloadInfo,
                "bomInfo": bomInfo,
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(downloadObj);
    }

    static bomAddItemsToCart = (dataPoints) => {
        let { productList, cartId, bomInfo } = dataPoints;
        const bomAddToCartEvent = {
            "event": BOM_ADD_ITEM_TO_CART,
            "_avnet": {
                productListItems: this.getBOMProductListItems(productList, BOM_ADD_ITEM_TO_CART),
                "ecommerce": {
                    "cartID": cartId
                },
                ...(bomInfo ? { bomInfo } : {}),
                ...this.defaultInfo()
            }
        };
        // if (!window.adobeDataLayer) {
        //     window.adobeDataLayer = [];
        // }
        window?.adobeDataLayer?.push(bomAddToCartEvent);
    }

    static errorDetail = (dataPoints) => {
        let { errorInfo } = dataPoints;
        const errorDetail = {
            "event": ERROR_DETAILS,
            "_avnet": {
                "errorInfo": errorInfo,
                ...this.defaultInfo()
            }
        }
        if (window?.adobeDataLayer && window?.adobeDataLayer?.filter(x => x.event == ERROR_DETAILS && x['_avnet']?.errorInfo?.errorName == errorInfo?.errorName).length == 0) {
            // this.getWindowObj();
            window?.adobeDataLayer?.push(errorDetail);
        }
    }

    static formStart = (dataPoints) => {
        let { formDetails } = dataPoints;
        const formStart = {
            "event": FORM_START,
            "_avnet": {
                "formDetails": formDetails,
                ...this.defaultInfo()
            }
        }
        // this.getWindowObj();
        window?.adobeDataLayer?.push(formStart);
    }

    static registrationStart = () => {
        const registrationStart = {
            "event": REGISTRATION_START,
            "data": {
                "identitymap": {
                    userID:[{}]
                }
            }
        }
        // this.getWindowObj();
        window?.adobeDataLayer?.push(registrationStart);
    }

    static registrationComplete = (dataPoints) => {
        let { userId } = dataPoints;
        const registrationComplete = {
            "event": REGISTRATION_COMPLETE,
            "data": {
                "identitymap": {
                    userID: [{ "id": userId }]
                }
            }
        }
        // this.getWindowObj();
        window?.adobeDataLayer?.push(registrationComplete);
    }

    static ctaClickEvent = (dataPoints) => {
        let { linkInfo } = dataPoints;
        const ctaClickInfo = {
            "event": CTACLICK,
            "_avnet": {
                linkInfo: linkInfo,
                ...this.defaultInfo()
            }
        }
        // this.getWindowObj();
        window?.adobeDataLayer?.push(ctaClickInfo);
    }

    static exportEvent = (dataPoints) => {
        let { productList, exportInfo } = dataPoints;
        const exportEvent = {
            "event": EXPORTS,
            "exportInfo": exportInfo,
            "productListItems": this.getBOMProductListItems(productList, EXPORTS),
        }

        // this.getWindowObj();
        window?.adobeDataLayer?.push(exportEvent);
    }

    static getWindowObj = () => {
        if (!window.adobeDataLayer) {
            window.adobeDataLayer = [];
        }
    }

    static formSubmission = (dataPoints) => {
        let { formDetails,linkInfo } = dataPoints;
        const formSubmission = {
            "event": FORM_SUBMISSION,
            "_avnet": {
                "formDetails": formDetails,
                "linkInfo": linkInfo,
                ...this.defaultInfo()
            }
        }
        // this.getWindowObj();
        window?.adobeDataLayer?.push(formSubmission);
    }
    static getCurrentTimeStamp() {
        const now = new Date();
        const timeStamp = now.toISOString();
        return timeStamp;
    }

    static removeLocalStorageEvent() {
        localStorage.removeItem("adobeEventType");
    }

    static loadAvnetAnalytics = () => {
        if (typeof avnetAnalytics === 'object') {
            console.log("avnetAnalytics init called")
            avnetAnalytics.init();
        }
    }
}

export default HelperAnalyticsEvent